import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector";
import { useCookieConsent } from "../contexts/CookieConsentContext";

function FooterComponent() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  // Get the correct hook values once
  const { setForceOpen } = useCookieConsent();

  const openConsentPreferences = (e) => {
    e.preventDefault();
    setForceOpen(true);
  };

  return (
    <footer className="py-5">
      <div className="container">
        <div className="row mb-2">
          <div className="col border-top"></div>
        </div>
        <div className="row g-0 g-lg-6 text-muted small">
          <div className="col-lg-6 text-lg-end order-lg-2">
            <ul className="list-inline small mb-2 mb-lg-0">
              <li className="list-inline-item ms-1">
                <a href="/privacy-policy" className="text-reset text-primary-hover">
                  {t("footer.privacyPolicy", "Privacy Policy")}
                </a>
              </li>
              <li className="list-inline-item ms-1">
                <a href="/terms-of-use" className="text-reset text-primary-hover">
                  {t("footer.termsOfUse", "Terms of Use")}
                </a>
              </li>
			  <li className="list-inline-item ms-1">
                <a
                  href="#cookies"
                  onClick={openConsentPreferences}
                  className="text-reset text-primary-hover"
                >
                  {t("footer.cookiePreferences", "Cookie Preferences")}
                </a>
              </li>
              <li className="list-inline-item ms-1">
                <LanguageSelector />
              </li>
            </ul>
          </div>
          <div className="col-lg-6 order-lg-1">
            <p className="small mb-0">
              &copy; {currentYear} Alberto Lussana. {t("footer.allRightsReserved", "All Rights Reserved")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterComponent;
